import { AbstractControl, ValidatorFn } from '@angular/forms';
import _ from 'lodash';

export function UniqueValidator(
  collection: Array<string>,
  caseSensitive: boolean = true,
  errorMessage: string = null
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (!control.value) {
      return null;
    }
    let value = control.value.trim();
    let unique = collection
      .filter((item) => !!item)
      .every((item) => notEqual(item.trim(), value, caseSensitive));
    return unique ? null : { unique: errorMessage ? errorMessage : true };
  };

  function notEqual(input: string, value: string, caseSensitive: boolean) {
    return caseSensitive ? input.toLowerCase() !== value.toLowerCase() : input !== value;
  }
}
